import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["data", "fetchMore"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo, useCallback } from "react";
import dynamic from "next/dynamic";
import List from "@/components/List";
import { useCanvasQuery } from "@/hooks";
import { CANVAS_PAGE_LIMIT } from "@/lib/constants";
import styles from "@/styles/Canvas.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HtmlSnippet = dynamic(function () {
  return import("@/components/HtmlSnippet");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/HtmlSnippet")];
    }
  }
});
var Palette = dynamic(function () {
  return import("@/components/Palette");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@/components/Palette")];
    }
  }
});

function CanvasStructure(_ref) {
  var item = _ref.item,
      hiddenPrice = _ref.hiddenPrice;
  var type = item.type,
      id = item.id;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [type === "palette" && /*#__PURE__*/_jsx(Palette, {
      id: id,
      hiddenPrice: hiddenPrice
    }), type === "html_snippet" && /*#__PURE__*/_jsx(HtmlSnippet, {
      id: id
    })]
  });
}

function Canvas(_ref2) {
  var idKey = _ref2.idKey,
      hiddenPrice = _ref2.hiddenPrice,
      title = _ref2.title;

  var _useCanvasQuery = useCanvasQuery({
    variables: {
      idKey: idKey.toString(),
      offset: 0,
      limit: CANVAS_PAGE_LIMIT
    },
    nextFetchPolicy: "cache-first"
  }),
      data = _useCanvasQuery.data,
      fetchMore = _useCanvasQuery.fetchMore,
      queryResult = _objectWithoutProperties(_useCanvasQuery, _excluded);

  var items = data === null || data === void 0 ? void 0 : data.canvas;
  var itemComponent = useCallback(function (_ref3) {
    var item = _ref3.item;
    return /*#__PURE__*/_jsx(CanvasStructure, {
      item: item,
      hiddenPrice: hiddenPrice
    });
  }, [hiddenPrice]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [title && /*#__PURE__*/_jsx("h1", {
      className: styles.title,
      children: title
    }), /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({
      items: items,
      limit: CANVAS_PAGE_LIMIT
    }, queryResult), {}, {
      itemComponent: itemComponent,
      fetchMore: fetchMore
    }))]
  });
}

export default /*#__PURE__*/memo(Canvas);